<template>
  <section>
    <PictureDialog ref="pictureDialog"></PictureDialog>
    <el-dialog
        :close-on-click-modal="false"
        title="请选择打印内容"
        :lock-scroll="true"
        :visible.sync="dialogFormVisible"
        width="500px"
    >
      <section v-loading="getDetailLoading" style="" class="dialog-content">
        <div  v-for="(item,index) in buttonList" :key="index" @click="() => toSelectType(index)" class="radioBox">
          <div :class="item.label===selectBtn ?'isSelected':'isSelect'">
           <span v-show="item.label===selectBtn" style="margin-right: 10px;width: 20px" >√</span>
            <span>{{item.label}}</span>
          </div>
        </div>

      </section>
      <section slot="footer" class="dialog-footer">
        <div class="tip">仅支持单选</div>
        <div>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button
              type="primary"
              @click="toPreview(originData,selectBtn)"
              :loading="subLoading || getDetailLoading"
          >预 览</el-button>
        </div>

      </section>
    </el-dialog>
  </section>

</template>

<script>
import PictureDialog from './pictureDialog';
export default {
  components: {
    PictureDialog,
  },
  data () {
    return {
      prePayInfo: {},
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      buttonList: [],
      selectBtn: '', // 选中的费用类型
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (tableTitle, selectResult) {
      this.dialogFormVisible = true; // 打开弹窗
      this.selectBtn = '';
      this.originData = selectResult;
      this.buttonList = [];
      tableTitle.forEach((item, index) => {
        if (index > 0) {
          this.buttonList.push(item);
        }
      });
    },

    toSelectType (index) { // 选择打印类型
      this.selectBtn = this.buttonList[index].label;
      this.buttonList[index].type = 'success';
    },

    async toPreview (originData, selectBtn) {
      if (this.selectBtn) {
        this.$refs.pictureDialog.show(originData, selectBtn);
      } else {
        this.$message.warning('请选择打印的费用类型');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper .el-dialog{
  background: #DDDDDD!important;
}
.dialog-content{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.radioBox{
  width: 120px;
}
.isSelected{
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  line-height: 1;
  padding: 15px;
  text-align: center;
  border-radius: 5px;
  margin: 8px;
  cursor: pointer;
  font-weight: 500;
}

.isSelect{
  line-height: 1;
  background: #fff;
  padding: 15px;
  text-align: center;
  border-radius: 5px;
  margin: 8px;
  border: 1px solid #dddddd;
  cursor: pointer;
  font-weight: 500;
}
.dialog-footer{
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.tip{
  font-size: 16px;
  color:#409eff;
  font-weight: 500;
}
</style>
